import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';

export function CHECKBOX__use_image_a_aspect_ratio() {
  const dispatch = use_dispatch();
  const { grid2d_image_compare__use_image_a_asperation_ratio, grid2d_image_compare__image_a } = use_slice_ui([
    'grid2d_image_compare__use_image_a_asperation_ratio',
    'grid2d_image_compare__image_a',
  ]);

  /*
   *
   */

  async function onCheckedChange() {
    dispatch(LOCAL__ui_set_boolean({ key: 'grid2d_image_compare__use_image_a_asperation_ratio', value: !grid2d_image_compare__use_image_a_asperation_ratio }));
  }

  /*
   *
   */
  function is_disabled() {
    return grid2d_image_compare__image_a.is_stub();
  }
  /*
   *
   */

  return (
    <div className="flex items-center gap-2">
      <UI_PRIMITIVE__checkbox
        id="CHECKBOX__use_image_a_aspect_ratio"
        checked={grid2d_image_compare__use_image_a_asperation_ratio}
        {...{ onCheckedChange }}
        className={``}
        disabled={is_disabled()}
      />
      <label
        htmlFor="CHECKBOX__use_image_a_aspect_ratio"
        className={`text-sm   text-bar-foreground text-xs
            ${is_disabled() ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
        `}
      >
        Use Image A Aspect Ratio
      </label>
    </div>
  );
}
